module.exports = __webpack_public_path__ + "img/leave-closure-warning.41833931.webp";